import { axios } from "../api/axiosShopify";

export const getItemShopifyService = async (data: any) => {
    return await axios.post('/products',data)
}

export const getBrandShopifyService = async (data: any) => {
    return await axios.post('/tags',data)
}

